import React from "react";

import OpenCardDetail from "../components/Kanban/openCardDetail";

function BoardDetailController({ boardId, cardId, cardsOnBoard, showCardPopup }) {
  if (!showCardPopup || !cardId) {
    return null;
  }

  return (
    <OpenCardDetail
      boardId={boardId}
      card={cardId}
      cardsOnBoard={cardsOnBoard}
    />
  );
}

export default BoardDetailController;
